import { withIntl } from "../../wrappers";
import { intlShape } from "../../shapes";
import ActionButton from "./ActionButton";

type Props = {
  intl: intlShape;
};

export function DetailsActionButton(props: Props) {
  return (
    <ActionButton
      {...props}
      icon="lcm-iot-icon-info"
      defaultLabel={props.intl.formatMessage({ id: "global.show_details" })}
      id="details-action-button"
    />
  );
}

export default withIntl(DetailsActionButton);
